import { render, staticRenderFns } from "./WechatBind.vue?vue&type=template&id=491bb39c&scoped=true&"
import script from "./WechatBind.vue?vue&type=script&lang=js&"
export * from "./WechatBind.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=491bb39c&prod&lang=scss&scoped=true&"
import style1 from "./WechatBind.vue?vue&type=style&index=1&id=491bb39c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491bb39c",
  null
  
)

export default component.exports